import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SLMap } from 'src/app/model/sl-map';
import { DictHandler, GeoLoc } from 'src/app/types/@types/sl-v-types';
// @ts-ignore
import { LngLat } from '!mapbox-gl';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { LngLatLike } from 'mapbox-gl';
import proj4 from 'proj4';
import { GeoLocationQualifierService } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';

@Component({
  selector: 'app-lng-lat-form',
  templateUrl: './lng-lat-form.component.html',
  styleUrls: ['./lng-lat-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LngLatFormComponent implements OnInit {

  @ViewChild('lonInput', { static: true }) lonInput: ElementRef;
  @ViewChild('latInput', { static: true }) latInput: ElementRef;

  private map: SLMap;
  public okHandler: DictHandler;
  public value: GeoLoc;
  public srcValue:GeoLoc;
  public units: string = 'degrees';
  public _proj: 'EPSG:4326' | 'EPSG:3857' | 'find' = 'EPSG:4326';
  set proj(prj: 'EPSG:4326' | 'EPSG:3857' | 'find') {
    this._proj = prj;
    if (this._proj !== 'find') {
      this.projection = {};
    }
    this.cdr.markForCheck;
    this.UpdateUnits();
  }
  get proj(): 'EPSG:4326' | 'EPSG:3857' | 'find' {
    return this._proj;
  }

  private _lngLat?: LngLat;
  @Input('lngLat')
  public set lngLat(pt: LngLat | undefined) {
    if(!pt) {
      if(!!this._lngLat) this._lngLat = undefined;
      this.Refresh();
      return;
    }
    this._lngLat = pt;
    (this.value as any) = {}
    this.value.lng = this._lngLat.lng;
    this.value.lat = this._lngLat.lat;
    this.value.point = pt;
    this.Refresh();
  }
  public get lngLat(): LngLatLike {
    return this._lngLat;
  }
  @Output()
  public lngLatChange = new EventEmitter<LngLatLike>();

  private _isAdvanced:boolean = false;
  @Input('isAdvanced')
  public set isAdvanced(adv:boolean) {
    if(this._isAdvanced === adv) return;
    this._isAdvanced = adv;
    this.Refresh();
  }
  public get isAdvanced():boolean {
    return this._isAdvanced;
  }
  public get isDegrees() {
    return this.units.toLowerCase().indexOf('degree') > -1;
  }

  private _projection: any = {};
  public set projection(prj: any) {
    this._projection = prj;
    window.requestAnimationFrame(() => {
      this.UpdateUnits();
    })
  }
  public get projection(): any {
    return this._projection;
  }

  public get hasProjection(): boolean {
    switch (this.proj) {
      case 'EPSG:3857':
      case 'EPSG:4326':
        return true;
      default:
        return Object.values(this._projection).length > 0;
    }
  }


  public get reqSelector() {
    // if(this.latInput.nativeElement.value === '') return false;
    // if(this.lonInput.nativeElement.value === '') return false;
    if (this._proj !== 'find') return false;
    return true;
  }
  constructor(private messager: ModalMessagerService, private cdr: ChangeDetectorRef) {

  }

  private _ready: boolean = false;
  ngOnInit() {
    $(this.lonInput.nativeElement).on('keyup', null, (event: any) => { this.UpdateValue(event); });
    $(this.latInput.nativeElement).on('keyup', null, (event: any) => { this.UpdateValue(event); });
    this._ready = true;
    this.Refresh();
  }
  SetUp(slMap: SLMap, okHandler: DictHandler) {
    this.map = slMap;
    this.okHandler = () => {
      const lng: number = this.value.lng;
      const lat: number = this.value.lat;
      /*if (isNaN(lat) || isNaN(lng)) {
        let badMessage = '';
        if (isNaN(lat)) {
          badMessage += '<p>The latitude value entered is not a number<p>';
        }
        if (isNaN(lng)) {
          badMessage += '<p>The longitude value entered is not a number<p>';
        }
        this.messager.Notify(badMessage, true, 'Invalid coordinate');
        return false;
      }*/

      if (okHandler) {
        let badLng = false;
        let badLat = false;
        if (lat < -90) {
          badLat = true;
        }
        if (lat > 90) {
          badLat = true;
        }
        if (lng < -180) {
          badLng = true;
        }
        if (lng > 180) {
          badLng = true;
        }
        let message = '';
        if (badLng || badLat) {
          message = '<h3>Invalid coordinate detected.</h3>';
          if (badLat === true) {
            message += 'Latitude value  ' + lat + ' should be in the range -90 to 90.<br>';
          }
          if (badLng === true) {
            message += 'Longitude value  ' + lng + ' should be in the range -180 to 180.';
          }
          message += '<p>Did you invert your cooridantes?<br>Latitude = Y-axis between -90deg South to 90deg North<br>Longitude = X-axis coordinates between -180deg West to 180deg East</p>';
          this.messager.Notify(message, true, 'Invalid coordinate');
          return false;
        }
        const pt: LngLat = new LngLat(lng, lat);
        this.value.lng = lng;
        this.value.lat = lat;
        this.value.point = pt;
        okHandler(this.value);
      }
    };
  }
  UpdateValue(event: any) {
    let lng: any = this.lonInput.nativeElement.value;
    let lat: any = this.latInput.nativeElement.value;
    if (this.isDegrees) {
      lng = GeoLocationQualifierService.GetDDegrees('' + lng);
      lat = GeoLocationQualifierService.GetDDegrees('' + lat);
    } else {
      lng = Number(lng);
      lat = Number(lat);
    }
    if (isNaN(lat) || isNaN(lng)) {
      return;
    }
    switch (this.proj) {
      case 'EPSG:4326':
        const pt: LngLat = { lng: lng, lat: lat }
        this.value = {
          lng: pt.lng,
          lat: pt.lat,
          point: pt,
          limitToExtent: false
        };
        break;
      case 'EPSG:3857':
        const [projLng, projLat] = proj4('EPSG:3857', 'EPSG:4326').forward([lng, lat]);
        this.value = {
          lng: projLng,
          lat: projLat,
          point: new LngLat(projLng, projLat),
          limitToExtent: false
        }
        break;
      case 'find':
        this.srcValue = {
          lng: lng,
          lat: lat,
          point: undefined,
          limitToExtent: false
        }
    }
    if(!!this.value) this.value.zoom = 18;
    if (event.keyCode === 13) {
      if (this.okHandler) {
        this.okHandler(this.value);
      }
    }
  }
  Submit() {
    this.UpdateValue({ keyCode: 13 });
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  UpdateUnits() {
    switch (this.proj) {
      case 'EPSG:3857':
        this.units = 'meter';
        break;
      case 'EPSG:4326':
        this.units = "Dec. Degree";
        break;
      default:
        if (!this.projection) {
          this.units = '';
        } else {
          this.units = '';
          const info = Object.values(this.projection)[0];
          if (!!info) {
            if (!!info['unit']) this.units = info['unit'].label;
            if (!!info['Unit']) this.units = info['Unit'].label;
            if (!!info['UNIT']) this.units = info['UNIT'].label;

          }
        }

    }
    this.cdr.markForCheck();
    this.Refresh();
  }
}
